import { render, staticRenderFns } from "./EntityBoardView.vue?vue&type=template&id=1225a651&scoped=true"
import script from "./EntityBoardView.vue?vue&type=script&lang=js"
export * from "./EntityBoardView.vue?vue&type=script&lang=js"
import style0 from "./EntityBoardView.vue?vue&type=style&index=0&id=1225a651&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1225a651",
  null
  
)

export default component.exports